import { render, staticRenderFns } from "./shipment-graph.vue?vue&type=template&id=3755f394&scoped=true&"
import script from "./shipment-graph.vue?vue&type=script&lang=js&"
export * from "./shipment-graph.vue?vue&type=script&lang=js&"
import style0 from "./shipment-graph.vue?vue&type=style&index=0&id=3755f394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755f394",
  null
  
)

export default component.exports